import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs'
import LazyLoad from 'react-lazyload';

import {Icon} from '@rmwc/icon'
import {Tooltip} from '@rmwc/tooltip'
import withSizes from 'react-sizes';
import { showToast } from '../services/toast';

import useUser from '../hooks/useUser';
import auth from '../services/auth';
import common from '../services/common';
import ga from '../services/ga';
import fetcher from '../services/fetcher';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser } from '@capgo/inappbrowser'

import '../css/coin-card.css';
import log from '../services/log';

function CoinCard(props) {
  const [user] = useUser()
  const [inPortfolio, setInPortfolio] = useState(user ? user.portfolio.includes(props.coin.coin) : false)
  const [isPortfolioUpdating, setIsPortfolioUpdating] = useState(false)
  const [rsi4hPeriod, setRsi4hPeriod] = useState(props.displayRsiPeriod !== '1d');
  const [coinInfo, setCoinInfo] = useState(null);
  const [isCoinInfoLoading, setIsCoinInfoLoading] = useState(false);
  const displayedRsi = rsi4hPeriod ? props.coin.rsi : props.coin.rsi_1d;
  const displayedRsiLabel = rsi4hPeriod ? 'RSI4h' : 'R1D';
  const displayedRsiTooltip = rsi4hPeriod ? 'Relative Strength Index 4h (RSI)' : 'Relative Strength Index 1D (RSI)';
  const displayedRsiAction = common.getActionByRSI(displayedRsi || props.coin.rsi);

  const getCoinInfo = async (coin) => {
    log.traceTag(`Getting coin info: ${coin}...`)
    setIsCoinInfoLoading(true);
    const result = await fetcher.getCoinInfo(coin);
    setCoinInfo(result);
    setIsCoinInfoLoading(false);
  } 

  useEffect(() => {
    //log.traceTag('Coin Info', coinInfo)
    if (coinInfo){
      var urls = coinInfo.data[props.coin.cmc_id].urls.website;
      log.traceTag('Coin Info', urls)

      if (Capacitor.getPlatform() === 'ios') {
        //await Browser.open({ url: `./tv/${coin.toUpperCase()}` });
        InAppBrowser.open({ url: urls[0] });
      } else {
        window.open(urls[0], '_blank')
      }
    }
  }, [coinInfo]);

  useEffect(() => {
    if (isPortfolioUpdating) {
      return;
    }

    setInPortfolio(user ? user.portfolio.includes(props.coin.coin) : false)
  }, [props.coin, user]);

  useEffect(() => {
    setRsi4hPeriod(props.displayRsiPeriod !== '1d');
  }, [props.displayRsiPeriod]);

  const togglePortfolio = async (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    if (isPortfolioUpdating) {
      return;
    }

    if (!inPortfolio){
      if (!auth.isProMembership() && user.portfolio.length >= 5){
        auth.showUnlockDialog();
        return;
      }

      setIsPortfolioUpdating(true)
      setInPortfolio(true)
      showToast(`Coin added to your portfolio`, 2000);
      try {
        await auth.addToPortfolio(props.coin.coin)
      } catch (err) {
        setInPortfolio(false)
        log.traceTag('addToPortfolio error', err);
      } finally {
        setIsPortfolioUpdating(false)
      }
    } else {
      setIsPortfolioUpdating(true)
      setInPortfolio(false)
      showToast(`Coin removed from your portfolio`, 2000);
      try {
        await auth.removeFromPortfolio(props.coin.coin)
      } catch (err) {
        setInPortfolio(true)
        log.traceTag('removeFromPortfolio error', err);
      } finally {
        setIsPortfolioUpdating(false)
      }
    }
  };

  return (
    <>
        <div 
          className={`100-w p-2 hovered coin ${common.getActionByRSI(props.coin.rsi).borderClass} ${(props.hideForFree) ? 'pro-coin' : ''} ${props.isMobile ? 'coin-card--force-mobile' : ''}`}
          onClick={() => { 
            ga.track({
              category: 'Retention',
              action: 'onCoinCardSelected',
              label: props.coin.coin
            })
            if (props.hideForFree){
              auth.showUnlockDialog()
            } else {
              props.onCoinSelected(props.coin.coin)}
            }
          }>
            <div className="pgRow" >
                <div className="col-auto pl-4 pr-5">
                    {props.hideForFree &&
                        <img style={{width: 28+'px', filter: `blur(3px)`}} src={props.coin.image}/>
                    } 
                    {!props.hideForFree &&
                        <img style={{width: 28+'px'}} src={props.coin.image}/>
                    } 
                </div>
                <div className="col-auto">
                    <div className="pgRow" >
                        <span className="coin-name">
                          {props.hideForFree &&
                            <b>PRO</b>
                          } 
                          {!props.hideForFree &&
                            <b>{props.coin.coin}</b>
                          } 
                        </span>
                        <span className="ml-2 small text-muted hide-small">
                          {props.hideForFree && !props.isAlert &&
                            <b>Unlock PRO to Track This Coin</b>
                          } 
                          {props.hideForFree && props.isAlert &&
                            <b>Unlock PRO to Get This Alert</b>
                          } 
                          {!props.hideForFree &&
                            <b>{props.coin.name}</b>
                          } 
                        </span>
                        <span className="ml-2 small text-muted rank">#{props.coin.rank}</span>
                       {!props.hideForFree &&
                          <Tooltip content="Learn About Project">
                            <span className="ml-2 clickable" onClick={(ev) => {
                              getCoinInfo(props.coin.cmc_id);
                              ev.stopPropagation()
                            }}>
                            <img style={{width: 14+'px'}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAApklEQVR4nO2VwQ0CMQwE0wSIkmgFmrR3pTTAPfgfhYAiHQ/ExfHF4XWs5J93J3KsJKW/tkhEzgAeAJ61Sos8PV9S1dkyIgpoNqyI5AHA7SeAnPMRwLT4pqEAfp78LiKnYQCuhLv8HgAr4UMANMJdsgCMhlsAOsO7RsQNJ+8CqOr1vedl76vmyCWLyKUVHgJ4tQOAOp5rNKpkmB9OBKKqc8nonUDap14h6gv6HnhP5QAAAABJRU5ErkJggg=="></img>
                            </span>
                          </Tooltip>
                        }
                    </div>
                    <div className="pgRow" >
                        <span className="small text-muted hide-small">Price:&nbsp;</span>
                        <span className="small coin-price">
                          <span className="">$</span>
                            {props.coin.current_price.toFixed(4)}
                          </span>
                          &nbsp;
                        {props.isAlert &&
                          <>
                            <span className="badge-alert hide-small">
                              <span className="small text-muted hide-small"> • Alert Price:&nbsp;</span>
                              <span className="small coin-price"><span className="">$</span>{props.signal.price.toFixed(5)}</span>&nbsp;
                            </span>
                          </>
                        }
                    </div>

                      <div className="pgRow hide-small" >
                        <>
                          {props.hideForFree &&
                            <span style={{filter: `blur(3px)`}}>
                            <Tooltip content="1h, 24h, 7d, 30d Price Change">
                              <span className="text-muted small"> <Icon style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">Ch%</span>:</span>
                            </Tooltip>
                            <span className={`ml-2 small ${(props.coin.change_1h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_1h.toFixed(2)}%</span>
                            <span className={`ml-2 small ${(props.coin.change_24h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_24h.toFixed(2)}%</span>
                            <span className={`ml-2 small ${(props.coin.change_7d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_7d.toFixed(2)}%</span>
                            <span className={`ml-2 small ${(props.coin.change_30d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_30d.toFixed(2)}%</span>
                            </span>
                          }
                          {!props.hideForFree &&
                            <>
                            <Tooltip content="1h, 24h, 7d, 30d Price Change">
                              <span className="text-muted small"> <Icon style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">Ch%</span>:</span>
                            </Tooltip>
                            <span className={`ml-2 small ${(props.coin.change_1h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_1h.toFixed(2)}%</span>
                            <span className={`ml-2 small ${(props.coin.change_24h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_24h.toFixed(2)}%</span>
                            <span className={`ml-2 small ${(props.coin.change_7d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_7d.toFixed(2)}%</span>
                            <span className={`ml-2 small ${(props.coin.change_30d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_30d.toFixed(2)}%</span>
                            </>
                          }
                        </>
                      </div>

                      {props.hideForFree &&
                          <div className="pgRow hide-large small" style={{filter: `blur(3px)`}}>
                            <span className={`small ${(props.coin.change_1h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_1h.toFixed(2)}%</span>
                            <span className={`ml-1 small ${(props.coin.change_24h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_24h.toFixed(2)}%</span>
                            <span className={`ml-1 small ${(props.coin.change_7d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_7d.toFixed(2)}%</span>
                          </div>
                      }
                      {!props.hideForFree &&
                          <div className="pgRow hide-large small">
                            <span className={`small ${(props.coin.change_1h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_1h.toFixed(2)}%</span>
                            <span className={`ml-1 small ${(props.coin.change_24h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_24h.toFixed(2)}%</span>
                            <span className={`ml-1 small ${(props.coin.change_7d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_7d.toFixed(2)}%</span>
                          </div>
                      }

                    {/*<div className="pgRow hide-large small">
                      <span className={`small ${(props.coin.change_1h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_1h.toFixed(2)}%</span>
                      <span className={`ml-1 small ${(props.coin.change_24h > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_24h.toFixed(2)}%</span>
                      <span className={`ml-1 small ${(props.coin.change_7d > 0) ? 'alert-buy' : 'alert-sell'}`}>{props.coin.change_7d.toFixed(2)}%</span>
                  </div>*/}
                </div>
                {!props.small &&
                  <div className="col hide-small text-left">
                    {props.hideForFree &&
                      <>
                        <div className="grid grid-cols-2 items-center gap-3 whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <LazyLoad style={{display: 'inline-block'}}>
                              <Tooltip content={`7 days ${props.coin.coin}/USDT price chart`}>
                                <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} className={`${props.coin.change_7d >= 0 ? 'graph-up' : 'graph-down'}`} title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px', filter: `blur(3px)`}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/${props.coin.cmc_id}.svg`}></img>
                              </Tooltip> 
                            </LazyLoad>
                            <span className="inline-flex items-center gap-1 whitespace-nowrap">
                              <Icon className="text-muted" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/>
                              <span className="text-muted small dashed">7d</span>
                            </span>
                          </div>
                          {/*<img title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px'}} src={`https://images.cryptocompare.com/sparkchart/${props.coin.coin}/USD/latest.png`}></img>*/}
                          <div className="flex items-center gap-2">
                            <LazyLoad style={{display: 'inline-block'}}>
                              <Tooltip content={`30 days ${props.coin.coin}/USDT price chart`}>
                                <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} className={`${props.coin.change_30d >= 0 ? 'graph-up' : 'graph-down'}`} title={`30 days ${props.coin.coin}/USDT price chart`} alt={`30 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px', filter: `blur(3px)`}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/30d/usd/${props.coin.cmc_id}.svg`}></img>
                              </Tooltip> 
                            </LazyLoad>
                            <span className="inline-flex items-center gap-1 whitespace-nowrap">
                              <Icon className="text-muted"  style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/>
                              <span className="text-muted small dashed">30d</span>
                            </span>
                          </div>
                        </div>
                      </>
                    }
                    {!props.hideForFree && !props.tv &&
                      <>
                        <div className="grid grid-cols-2 items-center gap-3 whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <LazyLoad style={{display: 'inline-block'}}>
                              <Tooltip content={`7 days ${props.coin.coin}/USDT price chart`}>
                                <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} className={`${props.coin.change_7d >= 0 ? 'graph-up' : 'graph-down'}`} title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px'}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/${props.coin.cmc_id}.svg`}></img>
                              </Tooltip> 
                            </LazyLoad>
                            <span className="inline-flex items-center gap-1 whitespace-nowrap">
                              <Icon className="text-muted" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/>
                              <span className="text-muted small dashed">7d</span>
                            </span>
                          </div>
                          {/*<img title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px'}} src={`https://images.cryptocompare.com/sparkchart/${props.coin.coin}/USD/latest.png`}></img>*/}
                          <div className="flex items-center gap-2">
                            <LazyLoad style={{display: 'inline-block'}}>
                              <Tooltip content={`30 days ${props.coin.coin}/USDT price chart`}>
                                <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} className={`${props.coin.change_30d >= 0 ? 'graph-up' : 'graph-down'}`} title={`30 days ${props.coin.coin}/USDT price chart`} alt={`30 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px'}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/30d/usd/${props.coin.cmc_id}.svg`}></img>
                              </Tooltip> 
                            </LazyLoad>
                            <span className="inline-flex items-center gap-1 whitespace-nowrap">
                              <Icon className="text-muted"  style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/>
                              <span className="text-muted small dashed">30d</span>
                            </span>
                          </div>
                        </div>
                      </>
                    }
                  </div>
                }
                {props.isAlert &&
                  <div className={`${props.isMobile ? 'col pl-0' : 'col-auto'}`}>
                      <div className="text-right mb-1 hide-small">
                          <span className="text-muted small">Alert Time:</span>
                          <span className="ml-1 small text-muted">{dayjs(props.signal.timestamp).format('hh:mm a')}</span>
                         <span> • </span>
                         <Tooltip content="CTB - Close To Buy, CTS - Close To Sell">
                          <span className="text-muted small hide-small"> <Icon  className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">Alert:</span></span>
                        </Tooltip>
                          <span className={`ml-1 font-weight-bold ${common.getColorByAction(props.signal.signal).alertClass}`}><b>{props.signal.signal}</b></span>
                      </div>

                      {/*<div className="hide-large text-right small">
                        <span className="small text-muted">
                            {dayjs(props.signal.timestamp).format('hh:mm a')}</span>
                      </div>*/}
                      <div className="hide-large text-right">
                        <span className={`font-weight-bold small ${common.getColorByAction(props.signal.signal).alertClass}`}><b>{props.signal.signal}</b></span>
                      </div>
                      
                      <div className="text-right" >
                      {props.isMobile && 
                          <>
                         {rsi4hPeriod &&
                            <>
                              <div onClick={(e) => { setRsi4hPeriod(!rsi4hPeriod);  e.stopPropagation(); }}>
                              <Tooltip content="Relative Strength Index 4h (RSI)">
                                <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">R4h</span>:</span>
                              </Tooltip>
                              <span className={`ml-2 hide-small ${common.getActionByRSI(props.coin.rsi).alertClass}`}><b>{props.coin.rsi.toFixed(2)}</b></span>
                              <span className={`ml-2 small hide-large ${common.getActionByRSI(props.coin.rsi).alertClass}`}><b>{props.coin.rsi.toFixed(2)}</b></span>
                              </div>
                            </>
                          }
                          {!rsi4hPeriod &&
                            <>
                              <div onClick={(e) => { setRsi4hPeriod(!rsi4hPeriod); e.stopPropagation();}}>
                              <Tooltip content="Relative Strength Index 4D (RSI)">
                                <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">R1D</span>:</span>
                              </Tooltip>
                              <span className={`ml-2 hide-small ${common.getActionByRSI(props.coin.rsi_1d).alertClass}`}><b>{props.coin.rsi_1d.toFixed(2)}</b></span>
                              <span className={`ml-2 small hide-large ${common.getActionByRSI(props.coin.rsi_1d).alertClass}`}><b>{props.coin.rsi_1d.toFixed(2)}</b></span>
                              </div>
                            </>
                          }
                         </>
                        }
                        {!props.isMobile &&
                          <>
                           <Tooltip content="Relative Strength Index 4h (RSI)">
                                <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">RSI (4h)</span>:</span>
                              </Tooltip>
                              <span className={`ml-2 hide-small ${common.getActionByRSI(props.coin.rsi).alertClass}`}><b>{props.coin.rsi.toFixed(2)}</b></span>
                              <span className={`ml-2 small hide-large ${common.getActionByRSI(props.coin.rsi).alertClass}`}><b>{props.coin.rsi.toFixed(2)}</b></span>
                            &nbsp;
                            <Tooltip content="Relative Strength Index 1d (RSI)">
                              <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">RSI<span className="hide-small"> (1D)</span></span>:</span>
                            </Tooltip>
                            <span className={`ml-2 hide-small ${common.getActionByRSI(props.coin.rsi_1d).alertClass}`}><b>{props.coin.rsi_1d ? props.coin.rsi_1d.toFixed(2) : '...'}</b></span>
                            <span className={`ml-2 small hide-large ${common.getActionByRSI(props.coin.rsi_1d).alertClass}`}><b>{props.coin.rsi_1d ? props.coin.rsi_1d.toFixed(2) : '...'}</b></span>
                          </>
                        }
                      </div>
                  </div>
                }
                {!props.isAlert &&
                  <div className={`${props.isMobile ? 'col' : 'col-auto'}`}>
                    <div className="text-right">
                        <Tooltip content="CTB - Close To Buy, CTS - Close To Sell">
                          <span className="text-muted small hide-small"> <Icon  className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">Now:</span></span>
                        </Tooltip>
                        <span className={`ml-2 font-weight-bold hide-small ${displayedRsiAction.alertClass}`}>{displayedRsiAction.action}</span>
                        <span className={`ml-2 font-weight-bold small hide-large ${displayedRsiAction.alertClass}`}>{displayedRsiAction.action}</span>
                    </div>
                    <div className="text-right" >
                        {props.isMobile && 
                          <>
                            <div onClick={(e) => { setRsi4hPeriod(!rsi4hPeriod);  e.stopPropagation(); }}>
                              <Tooltip content={displayedRsiTooltip}>
                                <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">{displayedRsiLabel}</span>:</span>
                              </Tooltip>
                              <span className={`ml-2 hide-small ${displayedRsiAction.alertClass}`}><b>{displayedRsi ? displayedRsi.toFixed(2) : '...'}</b></span>
                              <span className={`ml-2 small hide-large ${displayedRsiAction.alertClass}`}><b>{displayedRsi ? displayedRsi.toFixed(2) : '...'}</b></span>
                            </div>
                         </>
                        }
                        {!props.isMobile &&
                          <>
                           <Tooltip content="Relative Strength Index 4h (RSI)">
                                <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">RSI (4h)</span>:</span>
                              </Tooltip>
                              <span className={`ml-2 hide-small ${common.getActionByRSI(props.coin.rsi).alertClass}`}><b>{props.coin.rsi.toFixed(2)}</b></span>
                              <span className={`ml-2 small hide-large ${common.getActionByRSI(props.coin.rsi).alertClass}`}><b>{props.coin.rsi.toFixed(2)}</b></span>
                            &nbsp;
                            <Tooltip content="Relative Strength Index 1d (RSI)">
                              <span className="text-muted small"> <Icon className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">RSI<span className="hide-small"> (1D)</span></span>:</span>
                            </Tooltip>
                            <span className={`ml-2 hide-small ${common.getActionByRSI(props.coin.rsi_1d).alertClass}`}><b>{props.coin.rsi_1d ? props.coin.rsi_1d.toFixed(2) : '...'}</b></span>
                            <span className={`ml-2 small hide-large ${common.getActionByRSI(props.coin.rsi_1d).alertClass}`}><b>{props.coin.rsi_1d ? props.coin.rsi_1d.toFixed(2) : '...'}</b></span>
                          </>
                        }
                    </div>
                  </div>
                }
                <div
                  className="col-auto pl-2 pr-1 coin-card-action-zone"
                  onClick={(ev) => ev.stopPropagation()}
                  onMouseDown={(ev) => ev.stopPropagation()}
                  onPointerDown={(ev) => ev.stopPropagation()}
                  onTouchStart={(ev) => ev.stopPropagation()}
                >
                    {props.hideForFree &&
                      <Icon icon="lock" className='unlock-icon' /*style={{color: '#1d2238'}}*/ />
                    }
                    {!props.hideForFree &&
                      <button
                        type="button"
                        className="coin-card-star-button"
                        disabled={isPortfolioUpdating}
                        title="Add/Remove From Portfolio"
                        aria-label={`${inPortfolio ? 'Remove' : 'Add'} ${props.coin.coin} ${inPortfolio ? 'from' : 'to'} portfolio`}
                        onClick={togglePortfolio}
                        style={{ opacity: isPortfolioUpdating ? 0.75 : 1 }}
                      >
                        <Icon icon="star" style={{color: (inPortfolio ? 'orange' : 'grey')}} />
                      </button>
                    }
                </div>
            </div>
        </div>
    </>
  );
};

CoinCard.defaultProps = {
  isAlert: false,
  tv: false,
  displayRsiPeriod: '4h'
};

const mapSizesToProps = ({ width }, ownProps) => ({
  isMobile: ownProps.isMobile !== undefined ? ownProps.isMobile : width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(CoinCard);
